const GET_CONTACT_INFO_FROM_API = 'GET_CONTACT_INFO_FROM_API';
const GET_CHECKOUT_DETAILS_INCONTACT = 'GET_CHECKOUT_DETAILS_INCONTACT';
const ASYNC_FETCH = 'ASYNC_FETCH';
const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
const GET_CONTACT_INFO_SUCCESS = 'GET_CONTACT_INFO_SUCCESS';
const ERR_OCCURED = 'ERR_OCCURED';
const EDIT_LINK = 'EDIT_LINK';
const SHOW_CART = 'SHOWCART';
const UPDATE_SHOW_CART = 'UPDATE_SHOW_CART';
const POST_DATA = 'POST_DATA';
const POST_DATA_SUCCESS = 'POST_DATA_SUCCESS';
const GET_ZIPCODE_DETAILS = 'GET_ZIPCODE_DETAILS';
const IS_UPDATE_INFO_SUCCESS = 'IS_UPDATE_INFO_SUCCESS';
const UPDATE_SUCCESS_FLAG = 'UPDATE_SUCCESS_FLAG';
const CONTACT_INFO_EDIT_RESPONSE = 'CONTACT_INFO_EDIT_RESPONSE';
const UPDATE_ISPU_CONTACT_INFO = 'UPDATE_ISPU_CONTACT_INFO';
const CONTACT_INFO_ERRORS = 'CONTACT_INFO_ERRORS';
const EMAIL_VALIDATION_FROM_API = 'EMAIL_VALIDATION_FROM_API';
const PHONE_VALIDATION_FROM_API = 'PHONE_VALIDATION_FROM_API';
const POST_NON_VZ_CONSENT = 'POST_NON_VZ_CONSENT';
const UPDATE_SHIPPING_ADDRESS = 'UPDATE_SHIPPING_ADDRESS';
const UPDATE_SHIPPING_ADDRESS_SUCCESS = 'UPDATE_SHIPPING_ADDRESS_SUCCESS';
const DEFAULT_ERR_MSG = 'We are unable to process the request at this time. Please try after sometime';
const GET_CONT_INFO_ON_CLICK = 'GET_CONT_INFO_ON_CLICK';
const CONTACT_INFO_EDIT_ERROR = 'CONTACT_INFO_EDIT_ERROR';
const INVALID_ZIP_CODE = 'INVALID_ZIP_CODE';
const CONTACT_GET_ENABLED_DEVICES = 'CONTACT_GET_ENABLED_DEVICES';
const CONTACT_GET_DATA_SUCCESS = 'CONTACT_GET_DATA_SUCCESS';
const CONTACT_GET_ENABLED_DEVICES_SUCCESS = 'CONTACT_GET_ENABLED_DEVICES_SUCCESS';
const CONTACT_FETCH_SMS_DEVICES_SUCCESS = 'CONTACT_FETCH_SMS_DEVICES_SUCCESS';
const CONTACT_POST_SHIPPING_OPTION = 'CONTACT_POST_SHIPPING_OPTION';
const POST_SHIPPING_OPTION_SUCCESS = 'POST_SHIPPING_OPTION_SUCCESS';
const ACCOUNT_MAINTENENCE_EMAIL_VERIFICATION = 'ACCOUNT_MAINTENENCE_EMAIL_VERIFICATION';
const ACC_MAIN_EMAIL_VALIDATION = 'ACC_MAIN_EMAIL_VALIDATION';
const CI_INVALID_CASE_ERROR = 'CI_INVALID_CASE_ERROR';
const UPDATE_ISPU_CONTACT_INFO_SUCCESS_FLAG = 'UPDATE_ISPU_CONTACT_INFO_SUCCESS_FLAG';
const IS_UPDATE_ISPU_CONTACT_INFO_SUCCESS = 'IS_UPDATE_ISPU_CONTACT_INFO_SUCCESS';
const CEF_CONTACT_INFO_ERROR = 'CEF_CONTACT_INFO_ERROR';
const DEFAULT_ERROR_MESSAGE = 'Looks like something went wrong. Please try again later.';
const CREATE_UNIVERSAL_PROFILE = 'CREATE_UNIVERSAL_PROFILE';
const CREATE_UNIVERSAL_PROFILE_SUCCESS = 'CREATE_UNIVERSAL_PROFILE_SUCCESS';
const UNIVERSAL_PROFILE_BANNER_DISPLAYED = 'UNIVERSAL_PROFILE_BANNER_DISPLAYED';
const SHELL_CODE = 'SHELL_CODE';
const CREATE_UNIVERSAL_PROFILE_SUCCES_TOGGLE = 'CREATE_UNIVERSAL_PROFILE_SUCCES_TOGGLE';
const SHELL_VALIDATION_FAILED = 'SHELL_VALIDATION_FAILED';
const CREATE_UNIVERSAL_PROFILE_FAILURE = 'CREATE_UNIVERSAL_PROFILE_FAILURE';
const UNIVERSAL_PROFILE_BANNER_MESSAGES = 'UNIVERSAL_PROFILE_BANNER_MESSAGES';
const SHELL_RULES_CHECKBOX_STATE = 'SHELL_RULES_CHECKBOX_STATE';
const NON_VZ_CHECKBOX_VALUE = 'NON_VZ_CHECKBOX_VALUE';
const SHOW_TERMS_AND_CONDITIONS_BANNER = 'SHOW_TERMS_AND_CONDITIONS_BANNER';
const STORE_PREVIOUS_EMAIL = 'STORE_PREVIOUS_EMAIL';
const TOGGLE_UNIVERSAL_PROFILE_BANNER_DISPLAYED = 'TOGGLE_UNIVERSAL_PROFILE_BANNER_DISPLAYED';
const STORE_BLACK_LISTED_DETAILS = 'STORE_BLACK_LISTED_DETAILS';
const SHOW_EMAIL_EXIST_BANNER = 'SHOW_EMAIL_EXIST_BANNER';
const CALL_CRADLE_API = 'CALL_CRADLE_API_CONTACT_INFO';
const HARD_TO_GUESS_API = 'HARD_TO_GUESS_API';
const STORE_CRADLE_RESPONSE = 'STORE_CRADLE_RESPONSE';
const CRADLE_SUCCESS = '|FWA_C_SL_AC|';
const SEQ_UPDATE_PERSONAL_INFO_COMPLETED = 'SEQ_UPDATE_PERSONAL_INFO_COMPLETED';
const IS_CONTACT_INFO_EDITED = 'IS_CONTACT_INFO_EDITED';
const STORE_CRADLE_THROTTLE_LIST = 'STORE_CRADLE_THROTTLE_LIST';
const LATEST_SUCCESSFULLY_VERIFIED_EMAIL = 'LATEST_SUCCESSFULLY_VERIFIED_EMAIL';
const USPS_ADDRESS_VALIDATION = 'USPS_ADDRESS_VALIDATION';
const USPS_SHOW_MODAL = 'USPS_SHOW_MODAL';
const NAME_MAX_LENGTH = '40';

// Analytics Constants
const ANALYTICS_EVAR63_EXISTING_CUSTOMER = 'ph_ec';
const ANALYTICS_EVAR63_NEW_CUSTOMER = 'ph_n_ec';
const ANALYTICS_EVAR22_WELCOME_MODAL = 'welcome back - already have a verizon account modal';
const ANALYTICS_EVAR27_SIGN_IN = 'sign in';
const ANALYTICS_EVAR27_CLOSE = 'close';
const ANALYTICS_EVAR27_CONTINUE = 'continue';
const CRADLE_FLAG_CONTACTINFO_T_MODAL = 'FWA_CONTACTINFO_T_MODAL';

export {
  GET_CHECKOUT_DETAILS_INCONTACT,
  GET_CONTACT_INFO_FROM_API,
  ASYNC_FETCH,
  ASYNC_FETCH_SUCCESS,
  GET_CONTACT_INFO_SUCCESS,
  ERR_OCCURED,
  EDIT_LINK,
  SHOW_CART,
  UPDATE_SHOW_CART,
  POST_DATA,
  POST_DATA_SUCCESS,
  GET_ZIPCODE_DETAILS,
  IS_UPDATE_INFO_SUCCESS,
  UPDATE_SUCCESS_FLAG,
  CONTACT_INFO_EDIT_RESPONSE,
  UPDATE_ISPU_CONTACT_INFO,
  EMAIL_VALIDATION_FROM_API,
  PHONE_VALIDATION_FROM_API,
  POST_NON_VZ_CONSENT,
  UPDATE_SHIPPING_ADDRESS,
  UPDATE_SHIPPING_ADDRESS_SUCCESS,
  GET_CONT_INFO_ON_CLICK,
  DEFAULT_ERR_MSG,
  CONTACT_INFO_EDIT_ERROR,
  INVALID_ZIP_CODE,
  CONTACT_GET_ENABLED_DEVICES,
  CONTACT_GET_DATA_SUCCESS,
  CONTACT_GET_ENABLED_DEVICES_SUCCESS,
  CONTACT_FETCH_SMS_DEVICES_SUCCESS,
  CONTACT_POST_SHIPPING_OPTION,
  POST_SHIPPING_OPTION_SUCCESS,
  ACCOUNT_MAINTENENCE_EMAIL_VERIFICATION,
  ACC_MAIN_EMAIL_VALIDATION,
  CI_INVALID_CASE_ERROR,
  UPDATE_ISPU_CONTACT_INFO_SUCCESS_FLAG,
  IS_UPDATE_ISPU_CONTACT_INFO_SUCCESS,
  CEF_CONTACT_INFO_ERROR,
  DEFAULT_ERROR_MESSAGE,
  CREATE_UNIVERSAL_PROFILE,
  CREATE_UNIVERSAL_PROFILE_SUCCESS,
  UNIVERSAL_PROFILE_BANNER_DISPLAYED,
  CREATE_UNIVERSAL_PROFILE_SUCCES_TOGGLE,
  SHELL_CODE,
  SHELL_VALIDATION_FAILED,
  CREATE_UNIVERSAL_PROFILE_FAILURE,
  UNIVERSAL_PROFILE_BANNER_MESSAGES,
  SHELL_RULES_CHECKBOX_STATE,
  NON_VZ_CHECKBOX_VALUE,
  SHOW_TERMS_AND_CONDITIONS_BANNER,
  STORE_PREVIOUS_EMAIL,
  TOGGLE_UNIVERSAL_PROFILE_BANNER_DISPLAYED,
  STORE_BLACK_LISTED_DETAILS,
  SHOW_EMAIL_EXIST_BANNER,
  CALL_CRADLE_API,
  HARD_TO_GUESS_API,
  STORE_CRADLE_RESPONSE,
  CRADLE_SUCCESS,
  SEQ_UPDATE_PERSONAL_INFO_COMPLETED,
  IS_CONTACT_INFO_EDITED,
  STORE_CRADLE_THROTTLE_LIST,
  LATEST_SUCCESSFULLY_VERIFIED_EMAIL,
  CONTACT_INFO_ERRORS,
  USPS_ADDRESS_VALIDATION,
  USPS_SHOW_MODAL,
  NAME_MAX_LENGTH,
  ANALYTICS_EVAR63_EXISTING_CUSTOMER,
  ANALYTICS_EVAR63_NEW_CUSTOMER,
  ANALYTICS_EVAR22_WELCOME_MODAL,
  ANALYTICS_EVAR27_SIGN_IN,
  ANALYTICS_EVAR27_CONTINUE,
  ANALYTICS_EVAR27_CLOSE,
  CRADLE_FLAG_CONTACTINFO_T_MODAL,
};
